import React, { Component } from 'react'
import { connect } from 'react-redux'
import { IonList, IonItem, IonLabel, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonBadge } from '@ionic/react'
import Layout from '../../components/layout'
import PromoBar from '../../components/promoBar'
import { withTranslation } from '../../lib/translate'
import './index.css'
import { isDefined, isEmptyObject, forwardTo } from '../../lib/utils'
import { getConfig } from '../../appConfig'

const { hasOrdering, hasCampaignManager } = getConfig().appType

class Dashboard extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
	}

	render() {
		const { __, screenName, vouchers } = this.props
		return (
			<Layout hideSecondToolbar={ true } color="transparent" noPadding={ true }>
				<div className="absolute-content dash-layout"></div>
				<IonCard className="dash-card">
					<IonCardHeader>
						<IonCardTitle className="ion-text-center">{ __('Welcome Back') } { screenName }</IonCardTitle>
					</IonCardHeader>

					<IonCardContent className="dash-menu">
						<IonList>
							{ hasOrdering ?
								<IonItem className="clickable" onClick={ () => forwardTo('/click-and-collect') }>
									<div tabIndex="-1"></div>
									<IonLabel>{ __('Click & Collect') }</IonLabel>
								</IonItem> : null
							}
							<IonItem className="clickable" onClick={ () => forwardTo('/loyalty') }>
								<div tabIndex="-1"></div>
								<IonLabel>{ __('Loyalty') }</IonLabel>
							</IonItem>
							{ hasCampaignManager ?
								<IonItem className="clickable" onClick={() => forwardTo('/vouchers')}>
									<IonLabel>
										<div tabIndex="-1"></div>
										{ __('Vouchers')}
										{vouchers && vouchers.length === 0 ? null :
											<IonBadge color="primary" className="small">{vouchers.length}</IonBadge>
										}
										<IonBadge color="primary" className="small">{}</IonBadge>
									</IonLabel>
								</IonItem> : null
							}
							<IonItem className="clickable" onClick={ () => forwardTo('/account') }>
								<div tabIndex="-1"></div>
								<IonLabel>{ __('My Account') }</IonLabel>
							</IonItem>
							<IonItem className="clickable" onClick={ () => forwardTo('/locations') } lines="none">
								<div tabIndex="-1"></div>
								<IonLabel>{ __('Locations') }</IonLabel>
							</IonItem>
						</IonList>
					</IonCardContent>
				</IonCard>
				{ hasCampaignManager ? <PromoBar type={__('info')} vouchers= { vouchers }/> : null }
			</Layout>
		)
	}
}

const stateToProps = state => {
	const { profile, vouchers } = state.profile
	let screenName = ''
	if (isDefined(profile) && !isEmptyObject(profile) && profile.first_name) {
		screenName = profile.first_name
	}
	return {
		screenName,
		vouchers: vouchers || []
	}
}

export default connect(stateToProps)(withTranslation(Dashboard))
